import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Seo } from "@/components/Seo";
import { SocialLinks } from "@/components/SocialLinks";
import { activeSocials, WHATSAPP } from "@/lib/socials";

export default function Contact() {
  return (
    <div>
      <Seo
        title="Contact"
        path="/contact"
        description="Contact Yayra Glover Organic Inputs — WhatsApp/call +233 53 048 5235, email info@yayraglover.com, Organic Hill, Suhum, Eastern Region, Ghana."
      />
      <section className="bg-brand text-brand-bg noise-overlay">
        <div className="mx-auto max-w-4xl px-6 py-20 text-center">
          <span className="text-xs uppercase tracking-[0.28em] text-brand-ochre font-semibold">Get In Touch</span>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl">Say hello 👋</h1>
          <p className="mt-4 text-brand-bg/80 max-w-xl mx-auto">Questions about a product or your order? Reach out — we're happy to help.</p>
        </div>
      </section>

      <div className="mx-auto max-w-5xl px-6 py-16 grid gap-6 sm:grid-cols-3">
        <a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noreferrer" data-testid="contact-whatsapp"
          className="bg-white border border-brand/10 rounded-sm p-7 hover:shadow-lg hover:-translate-y-1 transition-[transform,box-shadow]">
          <MessageCircle className="w-8 h-8 text-brand-terracotta" strokeWidth={1.5} />
          <h3 className="mt-4 font-display text-xl text-brand">WhatsApp</h3>
          <p className="text-sm text-brand-muted mt-1">Chat with us instantly</p>
          <p className="text-sm font-medium text-brand mt-2">(+233) 053 048 5235</p>
        </a>
        <a href="tel:+233530485235" data-testid="contact-phone"
          className="bg-white border border-brand/10 rounded-sm p-7 hover:shadow-lg hover:-translate-y-1 transition-[transform,box-shadow]">
          <Phone className="w-8 h-8 text-brand-terracotta" strokeWidth={1.5} />
          <h3 className="mt-4 font-display text-xl text-brand">Call Us</h3>
          <p className="text-sm text-brand-muted mt-1">Mon – Sat, 8am – 6pm</p>
          <p className="text-sm font-medium text-brand mt-2">(+233) 053 048 5235</p>
        </a>
        <a href="mailto:info@yayraglover.com" data-testid="contact-email"
          className="bg-white border border-brand/10 rounded-sm p-7 hover:shadow-lg hover:-translate-y-1 transition-[transform,box-shadow]">
          <Mail className="w-8 h-8 text-brand-terracotta" strokeWidth={1.5} />
          <h3 className="mt-4 font-display text-xl text-brand">Email</h3>
          <p className="text-sm text-brand-muted mt-1">We reply within a day</p>
          <p className="text-sm font-medium text-brand mt-2 break-all">info@yayraglover.com</p>
        </a>
      </div>

      <div className="mx-auto max-w-5xl px-6 pb-20">
        <div className="bg-brand-surface rounded-sm p-8 flex items-start gap-4">
          <MapPin className="w-7 h-7 text-brand shrink-0" strokeWidth={1.5} />
          <div>
            <h3 className="font-display text-xl text-brand">Visit Us</h3>
            <p className="text-brand-muted mt-1">Organic Hill, Suhum, Eastern Region — Ghana</p>
            <a href="https://maps.google.com/?cid=6365415833127727225" target="_blank" rel="noreferrer">
              <Button variant="outline" className="mt-4 rounded-full border-brand/30 text-brand hover:bg-brand hover:text-white" data-testid="contact-directions">Get Directions</Button>
            </a>
          </div>
        </div>

        {activeSocials().length > 0 && (
          <div className="mt-10 text-center">
            <h3 className="text-xs uppercase tracking-[0.2em] text-brand-muted font-semibold">Follow us</h3>
            <div className="mt-4 flex justify-center"><SocialLinks variant="contact" /></div>
          </div>
        )}
      </div>
    </div>
  );
}
